// eslint-disable-next-line no-restricted-imports
import {view} from '@sail/ui';
import {SiteHeader} from '@sail/helm';
/* eslint-disable no-restricted-imports */
import {MarkdownSection} from 'mkt-ssr/components/sail/MarkdownSection/MarkdownSection';
import {SiteFooterSection} from 'mkt-ssr/components/sail/SiteFooterSection/SiteFooterSection';
/* eslint-enable no-restricted-imports */
import {createPage, InferPageProps} from 'mkt-ssr/lib/page';
import {createRouteGetServerSideProps} from 'mkt-ssr/lib/contentful/createRouteGetServerSideProps';
import {MarkdownPage} from '@stripe-internal/mkt-ssr-models';
import {ExperimentVariant} from 'mkt-ssr/components/ExperimentVariant/ExperimentVariant';
import type {Experiments} from 'mkt-ssr/@types/experiments/types';

export const getServerSideProps = createRouteGetServerSideProps(MarkdownPage);

const experimentId: keyof Experiments = 'wpp_react_experimentation_aa';
const tokenTypeExistingExperimentId: keyof Experiments =
  'wpp_token_type_aa_react_existing';
const tokenTypeNewExperimentId: keyof Experiments =
  'wpp_token_type_aa_react_new';

export default createPage(
  function Index({page}: InferPageProps<typeof getServerSideProps>) {
    return (
      <view.div>
        <SiteHeader theme="white" />

        {page.sections?.map(({identifier, body}) => (
          <MarkdownSection theme="white" key={identifier} markdown={body} />
        ))}

        <ExperimentVariant experimentId={experimentId} variantId="control">
          <div data-testid="control" style={{display: 'none'}} />
        </ExperimentVariant>

        <ExperimentVariant experimentId={experimentId} variantId="treatment">
          <div data-testid="treatment" style={{display: 'none'}} />
        </ExperimentVariant>

        <ExperimentVariant
          experimentId={tokenTypeExistingExperimentId}
          variantId="control"
        >
          <div
            data-testid="token-type-existing-control"
            style={{display: 'none'}}
          />
        </ExperimentVariant>

        <ExperimentVariant
          experimentId={tokenTypeExistingExperimentId}
          variantId="control_test"
        >
          <div
            data-testid="token-type-existing-control-test"
            style={{display: 'none'}}
          />
        </ExperimentVariant>

        <ExperimentVariant
          experimentId={tokenTypeNewExperimentId}
          variantId="control"
        >
          <div data-testid="token-type-new-control" style={{display: 'none'}} />
        </ExperimentVariant>

        <ExperimentVariant
          experimentId={tokenTypeNewExperimentId}
          variantId="control_test"
        >
          <div
            data-testid="token-type-new-control-test"
            style={{display: 'none'}}
          />
        </ExperimentVariant>

        <SiteFooterSection theme="white" hasBorderTop />
      </view.div>
    );
  },
  {
    metadata: ({page}) => ({
      analytics: {
        id: 'institutional',
        title: page.title || 'Institutional',
      },
      seo: {
        indexed: false,
      },
    }),
    pageConfig: {
      uiEngine: 'sail',
    },
  },
);
